var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 128,
    viewBox: "0 0 156 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2368_52035)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.8271 29.478C29.5344 31.5909 32.5002 36.8112 32.5002 41.0993V60.0537L44.9812 67.2626C48.6884 69.3756 51.6542 74.5959 51.6542 78.9461C51.6542 83.2341 48.6884 84.9742 44.9812 82.8613L32.5002 75.6523V94.6068C32.5002 98.8949 29.5344 100.635 25.8271 98.522C22.1199 96.409 19.1541 91.1888 19.1541 86.8386V67.8841L6.67306 60.6752C2.96582 58.5622 0 53.342 0 49.0539C0 44.7659 2.96582 43.0258 6.67306 45.1387L19.1541 52.3476V33.3932C19.1541 29.1051 22.1199 27.365 25.8271 29.478Z",
    fill: "url(#paint0_linear_2368_52035)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M61.0399 0L155.406 54.4588L155.392 128L61.0254 73.5412L61.0399 0Z",
    fill: "url(#paint1_linear_2368_52035)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M67.4004 36.6836L121.54 67.9357V70.2447L67.4004 38.9926V36.6836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M67.4004 41.3307L114.104 68.2842V70.5932L67.4004 43.6397V41.3307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M67.4004 45.9343L107.148 68.8796V71.1887L67.4004 48.2434V45.9343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M58.541 48.2288L98.1725 71.1015V91.5344L58.541 68.6472V48.2288Z",
    fill: "url(#paint2_linear_2368_52035)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M62.5352 55.7659L94.0196 73.9333V76.2424L62.5352 58.0749V55.7659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M62.5352 60.413L87.746 74.9644V77.2734L62.5352 62.7075V60.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M71.3061 10.9064C71.3061 12.4022 70.4347 13.0993 69.3601 12.4748C68.2854 11.8503 67.4141 10.1512 67.4141 8.65543C67.4141 7.15962 68.2854 6.46255 69.3601 7.08701C70.4347 7.71147 71.3061 9.42511 71.3061 10.9064Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2368_52035",
    x1: 38.7447,
    y1: 53.7272,
    x2: 6.25054,
    y2: 79.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2368_52035",
    x1: 124.137,
    y1: 36.4123,
    x2: 108.61,
    y2: 63.3196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2368_52035",
    x1: 82.7785,
    y1: 62.2116,
    x2: 74.6312,
    y2: 76.3267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2368_52035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 128,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardView);
export default __webpack_public_path__ + "static/media/dashboard-view.5dfc5638337fdff78d12bd85208d6bec.svg";
export { ForwardRef as ReactComponent };